import React from 'react';
import {Link, RouteComponentProps} from "react-router-dom";
import "./Register.less"
import TankComponent from "../../common/component/TankComponent";
import {Button, Col, Form, Input, Row} from 'antd';
import User from "../../common/model/user/User";
import Moon from "../../common/model/global/Moon";
import {LockOutlined, NumberOutlined, PhoneFilled, UserOutlined} from '@ant-design/icons';
import MessageBoxUtil from "../../common/util/MessageBoxUtil";
import Lang from "../../common/model/global/Lang";


interface IProps extends RouteComponentProps {

}

interface IState {
  phone: string;
}

export default class Register extends TankComponent<IProps, IState> {

  user: User = Moon.getSingleton().user

  constructor(props: IProps) {
    super(props);

    this.state = {
      phone: ""
    };
  }

  setPhone(e: any) {
    let value = e.target.value
    this.setState({
      phone: value
    })
  }

  componentDidMount() {

  }

  onFinish(values: any) {

    let that = this

    let user = that.user

    // user.httpRegister(values["username"], values["password"], function () {
    //   MessageBoxUtil.success(Lang.t("user.loginSuccess"))

    //   that.props.history.push('/')

    // })

    user.httpRegisterPhone(values["username"], values["password"], values["phone"], values["phonecode"], function () {
      MessageBoxUtil.success(Lang.t("user.loginSuccess"))

      that.props.history.push('/')

    })


  };

  onFinishFailed(errorInfo: any) {

  };

  onGetCode() {
    let that = this
    let user = that.user
    const {phone} = this.state

    if ( phone.length != 11 ) {
      MessageBoxUtil.error(Lang.t("user.phoneError"))
      return
    }

    user.httpRegisterPhoneCode(phone, function () {
      MessageBoxUtil.success(Lang.t("user.codeSuccess"))

    })
  }


  render() {

    let that = this
    const {phone} = this.state

    return (
      <div className="user-register">

        <Row>
          <Col xs={{span: 24}} md={{span: 8, offset: 6}}>

            <div className="welcome">
              {Lang.t("user.welcomeRegister")}
            </div>

            <Form
              name="basic"
              initialValues={{remember: true}}
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed.bind(this)}
            >
              <Form.Item
                name="username"
                rules={[{required: true, message: Lang.t("user.enterUsername")}]}
              >
                <Input size="large" placeholder={Lang.t("user.enterUsername")} prefix={<UserOutlined/>}/>
              </Form.Item>

              <Form.Item
                name="password"
                rules={[{required: true, message: Lang.t("user.enterPassword")}]}
              >
                <Input.Password size="large" placeholder={Lang.t("user.enterPassword")} prefix={<LockOutlined/>}/>
              </Form.Item>

              <Form.Item
                name="rePassword"
                dependencies={['password']}
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: Lang.t("user.enterPassword"),
                  },
                  ({getFieldValue}) => ({
                    validator(rule, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(Lang.t("user.passwordNotSame"));
                    },
                  }),
                ]}
              >
                <Input.Password size="large" placeholder={Lang.t("user.confirmPassword")} prefix={<LockOutlined/>}/>
              </Form.Item>



              <Form.Item
                name="phone"
                rules={[{required: true, message: Lang.t("user.enterPhone")}]}
              >
                <Input value={phone} onChange={(e)=>{this.setPhone(e)}} size="large" placeholder={Lang.t("user.enterPhone")} prefix={<PhoneFilled/>}/>
              </Form.Item>
              <div className="getregisterphonecode" onClick={this.onGetCode.bind(this)}>{Lang.t("user.getPhonecode")}</div>



              <Form.Item
                name="phonecode"
                rules={[{required: true, message: Lang.t("user.enterPhonecode")}]}
              >
                <Input size="large" placeholder={Lang.t("user.enterPhonecode")} prefix={<NumberOutlined/>}/>
              </Form.Item>


              <Form.Item>
                <Button type="primary" icon={<UserOutlined/>} block={true} htmlType="submit">
                  {Lang.t("user.register")}
                </Button>
              </Form.Item>


              <div className="text-right">
                <Link to={"/user/login"} className="loginuser">
                  <span className="link">{Lang.t("user.goToLogin")}</span>
                </Link>

                <Link to={"/user/loginphone"}>
                  <span className="link">{Lang.t("user.toLoginPhone")}</span>
                </Link>
              </div>


            </Form>

          </Col>
        </Row>

      </div>
    );
  }
}


